import React from 'react';
import './SubscribeFloatModal.scss';
import { useState } from 'react';
import {API} from '../../../services/api'

const SubscribeFloatModal = () => {
    /**
     * Componente para suscribirse
     * Es unn modal qeu permite enviar el nombre y el email
     */
    const [showModal, setShowModal] = useState(true);

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");

    const sendData = () => {
        /**
         * Registrar suscriptor
         * Se hace le llamado al servicio /subscribers/register-subscriber
         */
        API.postRegisterSuscriber({
            name: name,
            email: email
        })
        .then(x => {
            setShowModal(false);
        })
        .catch(x => {
            setShowModal(false);
        });
    }

    return (
        <div className={(showModal === false ? "SubscribeFloatModalMasterContainerHide " : "") + "SubscribeFloatModalMasterContainer"}>
            <form onSubmit={(e) => {
                e.preventDefault();
                e.stopPropagation();
                sendData();
            }}>
                <div className="div100 toLeft">
                    <div onClick={() => { setShowModal(false) }} className="closeModal">
                        <span>x</span>
                    </div>
                </div>
                <div style={{ marginTop: "-13px" }}>
                    <div className="div100">
                        <span className="titleSpan">Suscríbete aquí</span>
                    </div>

                    <div className="div100">
                        <span className="contentSpan">Ingresa tus datos para recibir información relevante de la pesca artesanal en Chile</span>
                    </div>

                    <div className="div100">
                        <input required value={name} onChange={(event) => { setName(event.target.value); }} className="textInput" placeholder="Nombre" type="text" />
                    </div>

                    <div className="div100">
                        <input required value={email} onChange={(event) => { setEmail(event.target.value); }} className="textInput" placeholder="Correo electrónico" type="text" />
                    </div>

                    <div className="div100">
                        <input className="submitButton" type="submit" value="Enviar" />
                    </div>
                </div>
            </form>
        </div>
    )
}

export default SubscribeFloatModal;